import { writable, readable } from "svelte/store"
import { tweened } from "svelte/motion";
import { cubicOut } from "svelte/easing";
import { derived } from "svelte/store";

export const soundBlobs = writable([])
export const sounds = writable({})

export const langId = writable('en')

export const planets = writable([])

export const loading = writable(true)

export const newPlanet = writable(false)

export const message = writable("")

export const fadeOutFlag = writable(true)
export const msgTimeouts = writable([])

export const helpFlag = writable(false)
export const planetInfoFlag = writable(false)

export const mode = writable("easy")
export const taxi = writable("a")
export const praxi = writable("prosthesi")

export const progress = tweened(0, {
  duration: 400,
  easing: cubicOut,
});

export const config = readable({
  numStars: 50,
  positiveAnswer: 10,
  negativeAnswer: 2,
  totalChoices: 3,
  minNumber: 1,
})

export const difficulty = readable({
  prosthesi: {
    a: [
      {
        stage: 1,
        targetMin: 2,
        targetMax: 20,
        totalChoices: 3,
        kratoumeno: false,
        mode: 'easy'
      },
      {
        stage: 3,
        targetMin: 10,
        targetMax: 50,
        totalChoices: 4,
        kratoumeno: false,
        mode: 'easy'
      },
      {
        stage: 5,
        targetMin: 40,
        targetMax: 99,
        totalChoices: 5,
        kratoumeno: false,
        mode: 'easy'
      },
    ],

    b: [
      {
        stage: 1,
        targetMin: 19,
        targetMax: 30,
        totalChoices: 4,
        kratoumeno: false,
        mode: 'easy'
      },
      {
        stage: 3,
        targetMin: 19,
        targetMax: 60,
        totalChoices: 5,
        kratoumeno: false,
        mode: 'easy'
      },
      {
        stage: 5,
        targetMin: 40,
        targetMax: 99,
        totalChoices: 6,
        kratoumeno: false,
        mode: 'easy'
      },
    ],

    c: [
      {
        stage: 1,
        targetMin: 19,
        targetMax: 50,
        totalChoices: 3,
        kratoumeno: true,
        mode: 'complex'
      },
      {
        stage: 2,
        targetMin: 30,
        targetMax: 80,
        totalChoices: 4,
        kratoumeno: true,
        mode: 'complex'
      },
      {
        stage: 5,
        targetMin: 60,
        targetMax: 99,
        totalChoices: 5,
        kratoumeno: true,
        mode: 'complex'
      },
    ],
  },
  propaideia: {
    b: [
      {
        stage: 1,
        targetMin1: 1,
        targetMax1: 3,
        targetMin2: 3,
        targetMax2: 7,
        totalChoices: 3,
        kratoumeno: false,
        mode: 'easy'
      },
      {
        stage: 3,
        targetMin1: 2,
        targetMax1: 6,
        targetMin2: 3,
        targetMax2: 10,
        totalChoices: 4,
        kratoumeno: false,
        mode: 'easy'
      },
      {
        stage: 5,
        targetMin1: 3,
        targetMax1: 9,
        targetMin2: 4,
        targetMax2: 10,
        totalChoices: 5,
        kratoumeno: false,
        mode: 'easy'
      },
    ],

    c: [
      {
        stage: 1,
        targetMin1: 1,
        targetMax1: 9,
        targetMin2: 2,
        targetMax2: 10,
        totalChoices: 4,
        kratoumeno: false,
        mode: 'easy'
      },
      {
        stage: 2,
        targetMin1: 3,
        targetMax1: 9,
        targetMin2: 4,
        targetMax2: 10,
        totalChoices: 5,
        kratoumeno: false,
        mode: 'easy'
      },
      {
        stage: 5,
        targetMin1: 6,
        targetMax1: 9,
        targetMin2: 6,
        targetMax2: 10,
        totalChoices: 6,
        kratoumeno: false,
        mode: 'easy'
      },
    ],
  }
})

export const state = writable({
  planetIndex: 0,
  selectedNums: 0,
  targetNum: null,
  numbers: [],
  currentCell: 1,
  rocketFull: false,
  scorePositive: 0,
  scoreNegative: 0,
  finished: false,
  restartClicked: false,
})

export const fullScreen = writable(false);


export const planetIndex = derived(state, ({ planetIndex }) => planetIndex);
